import { Icon } from '@chakra-ui/react';
import Customers from 'pages/customers';
import CustomerDetail from 'pages/customers/detail-index';
import Deadlines from 'pages/deadlines';
import Home from 'pages/home';
import Models from 'pages/models';
import Employees from 'pages/employees';
import TasksPage from 'pages/tasks';
import EmployeeTasks from 'pages/employee-tasks';
import FillReportPage from 'pages/intervention-reports/FillReportPage';
import ReportDetailPage from 'pages/intervention-reports/ReportDetailPage';
import NotificationsPage from 'pages/notifications';
import { FaUsers } from "react-icons/fa";
import { HiBellAlert } from "react-icons/hi2";
import { IoHome } from "react-icons/io5";
import { RiPagesFill } from "react-icons/ri";
import { MdPeople, MdCalendarMonth, MdAssignment } from "react-icons/md";
import Configurations from "./pages/configurations";

const routes: RoutesType[] = [
	{
		name: 'Home',
		layout: '/admin',
		path: '/home',
		icon: <Icon as={IoHome} width='20px' height='20px' marginTop='7px' color='inherit' />,
		component: Home,
		requireAdmin: true,
	},
	{
		name: 'Dettaglio Cliente',
		layout: '/admin',
		path: '/anagrafica-clienti/:id',
		component: CustomerDetail,
		hidden: true,
		requireAdmin: true,
	},
	{
		name: 'Anagrafica Clienti',
		layout: '/admin',
		path: '/anagrafica-clienti',
		icon: <Icon as={FaUsers} width='20px' height='20px' marginTop='7px' color='inherit' />,
		component: Customers,
		requireAdmin: true,
	},
	{
		name: 'Anagrafica Dipendenti',
		layout: '/admin',
		path: '/dipendenti',
		icon: <Icon as={MdPeople} width='20px' height='20px' marginTop='7px' color='inherit' />,
		component: Employees,
		requireAdmin: true,
	},
	{
		name: 'Scadenze',
		layout: '/admin',
		path: '/scadenze',
		icon: <Icon as={HiBellAlert} width='20px' height='20px' marginTop='7px' color='inherit' />,
		component: Deadlines,
		requireAdmin: true,
	},
	{
		name: 'Piano Settimanale',
		layout: '/admin',
		path: '/piano-settimanale',
		icon: <Icon as={MdCalendarMonth} width='20px' height='20px' marginTop='7px' color='inherit' />,
		component: TasksPage,
		requireAdmin: true,
	},
	{
		name: 'Compila Rapporto d\'Intervento',
		layout: '/admin',
		path: '/interventi/:taskId/rapporto',
		component: FillReportPage,
		hidden: true,
		requireAdmin: true,
		breadcrumbParent: { name: 'Piano Settimanale', path: '/admin/piano-settimanale' },
	},
	{
		name: 'Rapporto d\'Intervento',
		layout: '/admin',
		path: '/rapporti-intervento/:id',
		component: ReportDetailPage,
		hidden: true,
		requireAdmin: true,
		breadcrumbParent: { name: 'Piano Settimanale', path: '/admin/piano-settimanale' },
	},
	{
		name: 'Modelli',
		layout: '/admin',
		path: '/modelli',
		icon: <Icon as={RiPagesFill} width='20px' height='20px' marginTop='7px' color='inherit' />,
		component: Models,
		requireAdmin: true,
	},
	{
        name: 'Configurazioni',
        layout: '/admin',
        path: '/configurazioni',
        hidden: true,
        component: Configurations,
        requireAdmin: true,
    },
	{
		name: 'Notifiche',
		layout: '/admin',
		path: '/notifiche',
		hidden: true,
		component: NotificationsPage,
		requireAdmin: true,
	},
	{
		name: 'Compila Rapporto d\'Intervento',
		layout: '/dipendente',
		path: '/interventi/:taskId/rapporto',
		component: FillReportPage,
		hidden: true,
		requireAdmin: false,
		breadcrumbParent: { name: 'I miei Interventi', path: '/dipendente/interventi' },
	},
	{
		name: 'Rapporto d\'Intervento',
		layout: '/dipendente',
		path: '/rapporti-intervento/:id',
		component: ReportDetailPage,
		hidden: true,
		requireAdmin: false,
		breadcrumbParent: { name: 'I miei Interventi', path: '/dipendente/interventi' },
	},
	{
		name: 'I miei Interventi',
		layout: '/dipendente',
		path: '/interventi',
		icon: <Icon as={MdAssignment} width='20px' height='20px' marginTop='7px' color='inherit' />,
		component: EmployeeTasks,
		requireAdmin: false,
	},
	{
		name: 'Home Dipendente',
		layout: '/dipendente',
		path: '/home',
		icon: <Icon as={IoHome} width='20px' height='20px' marginTop='7px' color='inherit' />,
		component: Home,
		requireAdmin: false,
		hidden: true,
	},
];

export default routes;
